
console.log('file loaded');
/*============================================================================
  Ajax the add to cart experience by revealing it in a side drawer
  Plugin Documentation - http://shopify.github.io/Timber/#ajax-cart
  (c) Copyright 2015 Shopify Inc. Author: Carson Shold (@cshold). All Rights Reserved.

  This file includes:
    - Basic Shopify Ajax API calls
    - Ajax cart plugin

  This requires:
    - jQuery 1.8+
    - handlebars.min.js (for cart template)
    - modernizr.min.js
    - snippet/ajax-cart-template.liquid

  Customized version of Shopify's jQuery API
  (c) Copyright 2009-2015 Shopify Inc. Author: Caroline Schnapp. All Rights Reserved.
==============================================================================*/
if ((typeof ShopifyAPI) === 'undefined') { ShopifyAPI = {}; }

/*============================================================================
  API Helper Functions
==============================================================================*/
function attributeToString(attribute) {
  if ((typeof attribute) !== 'string') {
    attribute += '';
    if (attribute === 'undefined') {
      attribute = '';
    }
  }
  return window.wetheme.$.trim(attribute);
};

/*============================================================================
  API Functions
==============================================================================*/
ShopifyAPI.onCartUpdate = function(cart) {
  // alert('There are now ' + cart.item_count + ' items in the cart.');
};

ShopifyAPI.updateCartNote = function(note, callback) {
  var $body = window.wetheme.$(document.body),
  params = {
    type: 'POST',
    url: '/cart/update.js',
    data: 'note=' + attributeToString(note),
    dataType: 'json',
    beforeSend: function() {
      $body.trigger('beforeUpdateCartNote.ajaxCart', note);
    },
    success: function(cart) {
      if ((typeof callback) === 'function') {
        callback(cart);
      }
      else {
        ShopifyAPI.onCartUpdate(cart);
      }
      $body.trigger('afterUpdateCartNote.ajaxCart', [note, cart]);
    },
    error: function(XMLHttpRequest, textStatus) {
      $body.trigger('errorUpdateCartNote.ajaxCart', [XMLHttpRequest, textStatus]);
      ShopifyAPI.onError(XMLHttpRequest, textStatus);
    },
    complete: function(jqxhr, text) {
      $body.trigger('completeUpdateCartNote.ajaxCart', [this, jqxhr, text]);
    }
  };
  window.wetheme.$.ajax(params);
};

ShopifyAPI.onError = function(XMLHttpRequest, textStatus) {
  var data = eval('(' + XMLHttpRequest.responseText + ')');
  if (!!data.message) {
    alert(data.message + '(' + data.status  + '): ' + data.description);
  }
};

/*============================================================================
  POST to cart/add.js returns the JSON of the cart
    - Allow use of form element instead of just id
    - Allow custom error callback
==============================================================================*/
ShopifyAPI.addItemFromForm = function(form, callback, errorCallback) {
  console.log("HEARD 1");
  var $body = window.wetheme.$(document.body),
  params = {
    type: 'POST',
    url: '/cart/add.js',
    data: window.wetheme.$(form).serialize(),
    dataType: 'json',
    beforeSend: function(jqxhr, settings) {
      $body.trigger('beforeAddItem.ajaxCart', form);
    },
    success: function(line_item) {
      if ((typeof callback) === 'function') {
        callback(line_item, form);
      }
      else {
        ShopifyAPI.onItemAdded(line_item, form);
      }
      $body.trigger('afterAddItem.ajaxCart', [line_item, form]);
    },
    error: function(XMLHttpRequest, textStatus) {
      if ((typeof errorCallback) === 'function') {
        errorCallback(XMLHttpRequest, textStatus);
      }
      else {
        ShopifyAPI.onError(XMLHttpRequest, textStatus);
      }
      $body.trigger('errorAddItem.ajaxCart', [XMLHttpRequest, textStatus]);
    },
    complete: function(jqxhr, text) {
      $body.trigger('completeAddItem.ajaxCart', [this, jqxhr, text]);
    }
  };
  window.wetheme.$.ajax(params);
};

// Get from cart.js returns the cart in JSON
ShopifyAPI.getCart = function(callback) {
  window.wetheme.$(document.body).trigger('beforeGetCart.ajaxCart');
  window.wetheme.$.getJSON('/cart.js', function (cart, textStatus) {
    if ((typeof callback) === 'function') {
      callback(cart);
    }
    else {
      ShopifyAPI.onCartUpdate(cart);
    }
    window.wetheme.$(document.body).trigger('afterGetCart.ajaxCart', cart);
  });
};

// POST to cart/change.js returns the cart in JSON
ShopifyAPI.changeItem = function(line, quantity, callback) {
  var $body = window.wetheme.$(document.body),
  params = {
    type: 'POST',
    url: '/cart/change.js',
    data: 'quantity=' + quantity + '&line=' + line,
    dataType: 'json',
    beforeSend: function() {
      $body.trigger('beforeChangeItem.ajaxCart', [line, quantity]);
    },
    success: function(cart) {
      if ((typeof callback) === 'function') {
        callback(cart);
      }
      else {
        ShopifyAPI.onCartUpdate(cart);
      }
      $body.trigger('afterChangeItem.ajaxCart', [line, quantity, cart]);
    },
    error: function(XMLHttpRequest, textStatus) {
      $body.trigger('errorChangeItem.ajaxCart', [XMLHttpRequest, textStatus]);
      ShopifyAPI.onError(XMLHttpRequest, textStatus);
    },
    complete: function(jqxhr, text) {
      $body.trigger('completeChangeItem.ajaxCart', [this, jqxhr, text]);
    }
  };
  window.wetheme.$.ajax(params);
};
console.log('loaded here');
/*============================================================================
  Ajax Shopify Add To Cart
==============================================================================*/
var ajaxCart = (function(module, $) {

  'use strict';

  // Public functions
  var init, loadCart;

  // Private general variables
  var settings, isUpdating, $body;

  // Private plugin variables
  var $formContainer, $addToCart, $cartCountSelector, $cartCostSelector, $cartContainer, $drawerContainer;

  // Private functions
  var updateCountPrice, formOverride, itemAddedCallback, itemErrorCallback, cartUpdateCallback, buildCart, cartCallback, adjustCart, adjustCartCallback, createQtySelectors, qtySelectors, validateQty;

  /*============================================================================
    Initialise the plugin and define global options
  ==============================================================================*/
  init = function (options) {

    // Default settings
    settings = {
      formSelector       : 'form[action^="/cart/add"]',
      cartContainer      : '#CartContainer',
      addToCartSelector  : '[type="submit"]',
      cartCountSelector  : null,
      cartCostSelector   : null,
      moneyFormat        : '$',
      disableAjaxCart    : false,
      enableQtySelectors : true
    };

    // Override defaults with arguments
    $.extend(settings, options);

    // Select DOM elements
    $formContainer     = $(settings.formSelector);
    $cartContainer     = $(settings.cartContainer);
    $addToCart         = $formContainer.find(settings.addToCartSelector);
    $cartCountSelector = $(settings.cartCountSelector);
    $cartCostSelector  = $(settings.cartCostSelector);

    // General Selectors
    $body = $(document.body);

    // Track cart activity status
    isUpdating = false;

    // Setup ajax quantity selectors on the any template if enableQtySelectors is true
    if (settings.enableQtySelectors) {
      qtySelectors();
    }

    // Take over the add to cart form submit action if ajax enabled and use-ajax data is undefined or true
    if (!settings.disableAjaxCart) {
      console.log('override');
      formOverride();
    }

    // Run this function in case we're using the quantity selector outside of the cart
    adjustCart();
  };

  loadCart = function () {
    $body.addClass('drawer--is-loading');
    ShopifyAPI.getCart(cartUpdateCallback);
  };

  updateCountPrice = function (cart) {
    if ($cartCountSelector) {
      $('.site-header__cart-indicator').removeClass('hide');

      if (cart.item_count === 0) {
        $('.site-header__cart-indicator').addClass('hide');
      }
    }
  };

  formOverride = function () {
    console.log('form override');
    $formContainer.on('submit', function(evt) {
      evt.preventDefault();

      // Add class to be styled if desired
      $addToCart.removeClass('is-added').addClass('is-adding');

      // Remove any previous quantity errors
      $('.qty-error').remove();

      ShopifyAPI.addItemFromForm(evt.target, itemAddedCallback, itemErrorCallback);
    });

    $('#bundle-form').submit(function(e) {
      console.log("HEARD 2");
      e.preventDefault();
      console.log('submit');
      var variants = [];
      var variant_data = [];
      var properties = {};
      var letters = ["A","B","C","D","E","F","G","H","I","J","K","L","M","N","O","P","Q","R","S","T","U","V","W","X","Y","Z"]
      var var_string = "";

      $("[data-bundle-selector] option:selected").each(function() {
        variants.push($(this).val());
        variant_data.push( { "title" : $.trim($(this).data('title')), "id": $(this).data('variant') } );
      });

      for (var x = 0; x < variants.length; x++) {
        properties["Curation Item " + letters[x]] = "1x | " + variant_data[x]['title'];
      }
      properties["_image"] = $('[data-image-property]').val();
      properties["_title"] = $('[data-title-property]').val();
      for (var x = 0; x < variants_array.length; x++) {

        for (var y = 0; y < variants.length; y++) {
          if (variants_array[x].variant_sku.includes(variants[y]) && y == variants.length - 1) {
            var_string = variants_array[x].variant_id;
          } else if (variants_array[x].variant_sku.includes(variants[y]) && y < variants.length - 1) {
            continue;
          } else {
            break;
          }
        }
      }

      /* Plug Dev 11 Changes */
      let quantity = $("#BundleQuantity").length ? parseInt($("#BundleQuantity").val()) : 1;
      let id = var_string !== "" ? parseInt(var_string) : parseInt($('#bundle-form [name="id"]').val());

      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: {
          quantity: quantity,
          id: id,
          properties: properties
        },
        success: function() {
          ShopifyAPI.getCart(cartUpdateCallback);
        },
        dataType: 'json',
        error: function(error){
          console.log(error);
        }
      });
    });

  };

  itemAddedCallback = function (product) {
    $addToCart.removeClass('is-adding').addClass('is-added');

    ShopifyAPI.getCart(cartUpdateCallback);
  };

  itemErrorCallback = function (XMLHttpRequest, textStatus) {
    var data = eval('(' + XMLHttpRequest.responseText + ')');
    $addToCart.removeClass('is-adding is-added');

    if (!!data.message) {
      if (data.status == 422) {
        $formContainer.after('<div class="errors qty-error">'+ data.description +'</div>')
      }
    }
  };

  cartUpdateCallback = function (cart) {
    // Update quantity and price
    updateCountPrice(cart);
    buildCart(cart);
  };

  buildCart = function (cart) {
    // Start with a fresh cart div
    $cartContainer.empty();

    // Show empty cart
    if (cart.item_count === 0) {
      $cartContainer
        .append('<p class="empty-cart">' + "Your cart is currently empty." + '</p>');
      cartCallback(cart);
      return;
    }

    // Handlebars.js cart layout
    var items = [],
        item = {},
        data = {},
        source = $("#CartTemplate").html(),
        template = Handlebars.compile(source);

    // Bundles V2 - Plug Dev 11
    // When a bundle is added to the cart, the individual items are added only.
    // However, when displaying the bundle in the cart, we want it to appear as one item.
    var cartHasBundleItems;
    var usedInstanceIds = [];
    var instanceIdToBundleProduct = {};  // Don't actually exist in the cart.
    var bundleItems = cart.items.filter(function (cartItem) {
      return cartItem.properties._bundle_instance_id;
    });

    if (bundleItems.length) {
      console.log({cart});
      cartHasBundleItems = true;

      var instanceIds = bundleItems.reduce(function (instanceIds, bundleItem) {
        var instanceId = bundleItem.properties._bundle_instance_id;
        if (!instanceIds.includes(instanceId)) {
          instanceIds.push(instanceId);
        }
        return instanceIds;
      }, []);

      instanceIds.forEach(function (instanceId) {
        var instanceItems = bundleItems.filter(function (bundleItem) {
          return bundleItem.properties._bundle_instance_id === instanceId;
        });

        var firstInstanceItem = instanceItems.find(function (bundleItem) {
          return bundleItem.properties._bundle_handle;
        });

        var bundleImageSrc = firstInstanceItem.properties._bundle_image;
        if (!bundleImageSrc) {
          bundleImageSrc = "//cdn.shopify.com/s/assets/admin/no-image-medium-cc9732cb976dd349a0df1d39816fbcc7.gif";
        }

        var totalCents = instanceItems.reduce(function (totalCents, item) {
          totalCents += item.final_line_price;
          return totalCents;
        }, 0);

        instanceIdToBundleProduct[instanceId] = {
          // id: cartItem.variant_id,
          // line: index + 1, // Shopify uses a 1+ index in the API
          url: "/pages/" + firstInstanceItem.properties._bundle_page_handle,
          img: bundleImageSrc.replace(/(\.[^.]*)$/, "_300x$1").replace('http:', ''),
          imgResponsive: bundleImageSrc.replace(/(\.[^.]*)$/, "_{width}$1").replace("http:", ""),
          instanceId: instanceId,
          name: firstInstanceItem.properties._bundle_title,
          properties: {},
          // itemAdd: cartItem.quantity + 1,
          // itemMinus: cartItem.quantity - 1,
          itemQty: firstInstanceItem.properties._bundle_quantity,
          price: Shopify.formatMoney(totalCents, settings.moneyFormat),
          vendor: "Cadeaux",
          linePrice: Shopify.formatMoney(totalCents, settings.moneyFormat),
          originalPrice: Shopify.formatMoney(totalCents, settings.moneyFormat),
          type: "Bundles",
          isBundle: true,
          // discountsApplied: cartItem.original_line_price > 0 && cartItem.final_line_price < cartItem.original_line_price,
          /*discountAllocations: cartItem.line_level_discount_allocations.map(function (allocation) {
            allocation.money = Shopify.formatMoney(allocation.amount, settings.moneyFormat);
            return allocation;
          }),*/
          // unitPriceMeasurement: firstInstanceItem.unit_price_measurement,
          // unitPrice: cartItem.unit_price? Shopify.formatMoney(cartItem.unit_price, settings.moneyFormat) : null,
          // unitRefValue: cartItem.unit_price_measurement ? cartItem.unit_price_measurement.reference_value : null,
          // unitRefUnit: cartItem.unit_price_measurement ? cartItem.unit_price_measurement.reference_unit : null
        };

      });
    }


    // Add each item to our handlebars.js data
    $.each(cart.items, function(index, cartItem) {
      var instanceId = cartItem.properties._bundle_instance_id;

      if (instanceId) {
        if (usedInstanceIds.includes(instanceId)) {
          return;
        }

        usedInstanceIds.push(instanceId);
        item = instanceIdToBundleProduct[instanceId];
        items.push(item);
        return;
      }

      /* Hack to get product image thumbnail
       *   - If image is not null
       *     - Remove file extension, add _300x, and re-add extension
       *     - Create server relative link
       *     - Create responsive variant (`_{width}x` as size)
       *   - A hard-coded url of no-image
      */
      var prodImgResponsive = null
      if (cartItem.image != null){
        var prodImg = cartItem.image.replace(/(\.[^.]*)$/, "_300x$1").replace('http:', '');
        var prodImgResponsive = cartItem.image.replace(/(\.[^.]*)$/, "_{width}$1").replace('http:', '');
      } else {
        var prodImg = "//cdn.shopify.com/s/assets/admin/no-image-medium-cc9732cb976dd349a0df1d39816fbcc7.gif";
      }

      var properties = {};
        if(cartItem.properties) {
        Object.keys(cartItem.properties || {}).forEach(function (key) {
          if (key[0] !== '_') {
            properties[key] = cartItem.properties[key].replace(" / N/S", " ");
            properties[key] = properties[key].replace("1x | ", " ");
            if (!key.includes('Curation Item')) {
              properties[key] = key + ': ' + properties[key];
            }
            properties[key] = properties[key].replace(' - Default Title', ' ');
          }
        });
      }
      // Create item's data object and add to 'items' array
      item = {
        id: cartItem.variant_id,
        line: index + 1, // Shopify uses a 1+ index in the API
        url: cartItem.url,
        type: cartItem.product_type,
        img: prodImg,
        imgResponsive: prodImgResponsive,
        name: cartItem.product_title,
        variation: cartItem.variant_title,
        optionName: cartItem.options_with_values[0].name,
        properties: properties,
        itemAdd: cartItem.quantity + 1,
        itemMinus: cartItem.quantity - 1,
        itemQty: cartItem.quantity,
        price: Shopify.formatMoney(cartItem.price, settings.moneyFormat),
        vendor: cartItem.vendor,
        linePrice: Shopify.formatMoney(cartItem.final_line_price, settings.moneyFormat),
        originalPrice: Shopify.formatMoney((cartItem.original_line_price), settings.moneyFormat),
        discountsApplied: cartItem.original_line_price > 0 && cartItem.final_line_price < cartItem.original_line_price,
        discountAllocations: cartItem.line_level_discount_allocations.map(function (allocation) {
          allocation.money = Shopify.formatMoney(allocation.amount, settings.moneyFormat);
          return allocation;
        }),
        unitPriceMeasurement: cartItem.unit_price_measurement,
        unitPrice: cartItem.unit_price? Shopify.formatMoney(cartItem.unit_price, settings.moneyFormat) : null,
        unitRefValue: cartItem.unit_price_measurement ? cartItem.unit_price_measurement.reference_value : null,
        unitRefUnit: cartItem.unit_price_measurement ? cartItem.unit_price_measurement.reference_unit : null
      };
      if (cartItem.product_type == 'Bundles') {
        item.variation = null;
      }
      items.push(item);
    });

    // Gather all cart data and add to DOM
    data = {
      items: items,
      note: cart.note,
      totalPrice: Shopify.formatMoney(cart.total_price, settings.moneyFormat),
      totalCartOriginal: cart.original_total_price > cart.total_price ? Shopify.formatMoney(cart.original_total_price, settings.moneyFormat) : null,
      discountApplications: cart.cart_level_discount_applications.map(function (application) {
        application.money = Shopify.formatMoney(application.total_allocated_amount, settings.moneyFormat);
        return application;
      }),
    }

    $cartContainer.append(template(data));
    function getProducts(page) {
      var xhr = new XMLHttpRequest();
      var products = [];
      var currentProductType = "";
      xhr.open('GET', '/products.json?limit=250&page=' + page);
      xhr.send(null);

      xhr.onreadystatechange = function () {
        var DONE = 4; // readyState 4 means the request is done.
        var OK = 200; // status 200 is a successful return.

        if (xhr.readyState === DONE) {
          var counter = 0;
          if (xhr.status === OK) {
            var tempProducts = JSON.parse(xhr.response);
            products = tempProducts.products;
            for (var i = 0; i <= products.length; i++) {
                var productDescription = '<div class="grid-view-item--desc-wrapper"><p class="product-grid--title"><a href="/products/' + products[i].handle + '">' + products[i].title + '</a></p><p class="product-grid--price"><span class="money">' + products[i].variants[0].price + '</span></p></div>';
                var productImage = '<div class="grid__image grid-view-item-image"><a href="/products/' + products[i].handle + '"><img src="' + products[i].images[0].src + '"></a></div>';
                var grid = '<div class="product grid__item"><div class="grid-view-item">' + productImage + productDescription + '</div></div>';
                var container = '.plug-related-product__slideshow';
                var containerSelector = document.querySelector(container);
                containerSelector.innerHTML = containerSelector.innerHTML + grid;
                counter++;
                if (counter === 24 || i == products.length) {
                  containerSelector.setAttribute('data-related-products-slider-initiated','');
                  break;
                }
            }
          } else {
            console.log('Error: ' + xhr.status); // An error occurred during the request.
          }
        }
      };
      console.log(currentProductType);
    }
    cartCallback(cart);
  };

  cartCallback = function(cart) {
    $body.removeClass('drawer--is-loading');
    $body.trigger('afterCartLoad.ajaxCart', cart);
	if (window.Shopify && Shopify.StorefrontExpressButtons) {
		Shopify.StorefrontExpressButtons.initialize();
	}
  };

  adjustCart = function () {
    // Delegate all events because elements reload with the cart

    // Add or remove from the quantity
    $body.on('click', '.ajaxcart__qty-adjust', function() {
      if (isUpdating) {
        return;
      }

      var $el = $(this),
          line = $el.data('line'),
          row = $el[0].closest('.ajaxcart__row'),
          isBundle = row.dataset.isBundle,
          $qtySelector = $el.siblings('.ajaxcart__qty-num'),
          qty = parseInt($qtySelector.val().replace(/\D/g, ''));

      var qty = validateQty(qty);

      // Add or subtract from the current quantity
      if ($el.hasClass('ajaxcart__qty--plus')) {
        qty += 1;
      } else {
        qty -= 1;
        if (qty <= 0) qty = 0;
      }

      if (isBundle) {
        var instanceId = Number(row.dataset.instanceId);

        PLUG.utils.setLoadingState(row, true);
        row.classList.add("is-loading");

        return window.PLUG.BundleCartUtils.updateBundleQty(instanceId, qty, function (cart, error) {
          const errorMessageEle = row.querySelector(".ajaxcart__qty-error-message");
          if (error) {
            console.error(error);
            errorMessageEle.classList.remove("hidden");
            errorMessageEle.textContent = error;
            PLUG.utils.setLoadingState(row, false);
            row.classList.remove("is-loading");
          } else {
            errorMessageEle.classList.add("hidden");
            errorMessageEle.textContent = "";
            adjustCartCallback(cart);
          }
        });
      } else {
        // If it has a data-line, update the cart.
        // Otherwise, just update the input's number
        if (line) {
          updateQuantity(line, qty);
        } else {
          $qtySelector.val(qty);
        }
      }
    });

    // Add or remove from the quantity
    $body.on('click', '.ajaxcart__qty-remove', function() {
        if (isUpdating) {
            return;
        }

        var $el = $(this),
            line = $el.data('line'),
            isBundle = ($el[0].closest('.ajaxcart__row').dataset.isBundle === 'true'),
            qty = 0;

        if (isBundle) {
          var instanceId = Number(
              $el[0].closest('.ajaxcart__row').dataset.instanceId
          );

          return window.PLUG.BundleCartUtils.deleteBundle(instanceId, function (cart, error) {
            if (error) {
              console.error(error);
              return;
            }
            adjustCartCallback(cart);
          });
        }
        // Remove all items of this type from the cart
        if (line) {
            updateQuantity(line, qty);
        }
    });

    // Update quantity based on input on change
    $body.on('change', '.ajaxcart__qty-num', function(e) {
      e.preventDefault();
      e.stopImmediatePropagation();
      if (isUpdating) {
        return;
      }

      var $el = $(this),
          line = $el.data('line'),
          row = $el[0].closest('.ajaxcart__row'),
          isBundle = (row.dataset.isBundle === 'true'),
          qty = parseInt($el.val().replace(/\D/g, ''));

      var qty = validateQty(qty);

      if (isBundle) {
        var instanceId = Number(row.dataset.instanceId);

        return window.PLUG.BundleCartUtils.updateBundleQty(instanceId, qty, function (cart, error) {
          const errorMessageEle = row.querySelector(".ajaxcart__qty-error-message");
          if (error) {
            console.error(error);
            errorMessageEle.classList.remove("hidden");
            errorMessageEle.textContent = error;
          } else {
            errorMessageEle.classList.add("hidden");
            errorMessageEle.textContent = "";
            adjustCartCallback(cart);
          }
        });
      }

      // If it has a data-line, update the cart
      if (line) {
        updateQuantity(line, qty);
      }
    });

    // Prevent cart from being submitted while quantities are changing
    $body.on('submit', 'form.ajaxcart', function(evt) {
      evt.preventDefault();
      // if (isUpdating) {
      //   evt.preventDefault();
      // }
    });

    // Highlight the text when focused
    $body.on('focus', '.ajaxcart__qty-adjust', function() {
      var $el = $(this);
      setTimeout(function() {
        $el.select();
      }, 50);
    });

    function updateQuantity(line, qty) {
      isUpdating = true;

      // Add activity classes when changing cart quantities
      var $row = $('.ajaxcart__row[data-line="' + line + '"]').addClass('is-loading');
      PLUG.utils.setLoadingState($row[0], true);

      if (qty === 0) {
        $row.parent().addClass('is-removed');
      }

      // Slight delay to make sure removed animation is done
      setTimeout(function() {
        ShopifyAPI.changeItem(line, qty, adjustCartCallback);
      }, 250);
    }

    // Save note anytime it's changed
    $body.on('change', 'textarea[name="note"]', function() {
      var newNote = $(this).val();

      // Update the cart note in case they don't click update/checkout
      ShopifyAPI.updateCartNote(newNote, function(cart) {});
    });
  };

  adjustCartCallback = function (cart) {
    // Update quantity and price
    updateCountPrice(cart);

    // Reprint cart on short timeout so you don't see the content being removed
    setTimeout(function() {
      isUpdating = false;
      ShopifyAPI.getCart(buildCart);
    }, 150)
  };

  createQtySelectors = function() {
    // If there is a normal quantity number field in the ajax cart, replace it with our version
    if ($('input[type="number"]', $cartContainer).length) {
      $('input[type="number"]', $cartContainer).each(function() {
        var $el = $(this),
            row = $el[0].closest(".cart__row, .ajaxcart__row"),
            currentQty = $el.val(),
            parent = $el[0].parentElement;

        var itemAdd = currentQty + 1,
            itemMinus = currentQty - 1,
            itemQty = currentQty;

        var source   = $("#AjaxQty").html(),
            template = Handlebars.compile(source),
            data = {
              id: $el.data('id'),
              itemQty: itemQty,
              itemAdd: itemAdd,
              itemMinus: itemMinus
            };

        // Append new quantity selector then remove original
        $el.after(template(data)).remove();

        if (row.dataset.isBundle === "true") {
          PLUG.utils.afterNextFrame(function () {
            parent.querySelector(".js-qty__num").disabled = true;
          });
        }
      });
    }
  };

  qtySelectors = function() {
    // Change number inputs to JS ones, similar to ajax cart but without API integration.
    // Make sure to add the existing name and id to the new input element
    var numInputs = $('input[type="number"]');

    if (numInputs.length) {
      numInputs.each(function() {
        var $el = $(this),
            row = $el[0].closest(".cart__row, .ajaxcart__row"),
            parent = $el[0].parentElement,
            currentQty = parseInt($el.val()),
            inputName = $el.attr('name'),
            inputId = $el.attr('id');

        var itemAdd = currentQty + 1,
            itemMinus = currentQty - 1,
            itemQty = currentQty;

        var source   = $("#JsQty").html(),
            template = Handlebars.compile(source),
            data = {
              id: $el.data('id'),
              itemQty: itemQty,
              itemAdd: itemAdd,
              itemMinus: itemMinus,
              inputName: inputName,
              inputId: inputId
            };

        // Append new quantity selector then remove original
        $el.after(template(data)).remove();

        if (row.dataset.isBundle === "true") {
          PLUG.utils.afterNextFrame(function () {
            parent.querySelector(".js-qty__num").disabled = true;
          });
        }
      });

      // Setup listeners to add/subtract from the input
      $('.js-qty__adjust').on('click', function() {
        var $el = $(this),
            row = $el[0].closest(".cart__row"),
            id = $el.data('id'),
            price = $el.parents('[data-line-price]').data('line-price'),
            $qtySelector = $el.siblings('.js-qty__num'),
            qty = parseInt($qtySelector.val().replace(/\D/g, ''));

        var qty = validateQty(qty);
        var $lineWrapper = $el.parents('.table__section');
        var $lineTotal = $lineWrapper.find('[data-label="Total"]');

        // Add or subtract from the current quantity
        if ($el.hasClass('js-qty__adjust--plus')) {
          qty += 1;
        } else {
          qty -= 1;
          if (qty <= 1) qty = 1;
        }

        if (row.dataset.isBundle === "true") {
          var instanceId = Number(row.dataset.instanceId);
          row.classList.add("is-loading");
          PLUG.utils.setLoadingState(row, true);
          return window.PLUG.BundleCartUtils.updateBundleQty(instanceId, qty, function (cart, error) {
            const errorMessageEle = row.querySelector(".cart__item-qty-error-msg");
            if (error) {
              console.error(error);
              errorMessageEle.classList.remove("hidden");
              errorMessageEle.textContent = error;
              row.classList.remove("is-loading");
              PLUG.utils.setLoadingState(row, false);
            } else {
              errorMessageEle.classList.add("hidden");
              errorMessageEle.textContent = "";
              location.reload();
            }
          });
        }

        price = parseFloat(price);
        price = price / 100.00;

        // Update the input's number
        $qtySelector.val(qty);
        qty = qty.toFixed(2);

        $lineTotal.find(".money").html("$" + (qty * price) + ".00");

        qty = parseInt(qty);

        $.ajax({
          type: 'POST',
          url: '/cart/update.js?updates['+ id +']=' + qty,
          success: function(response) {
            console.log('ADDED TO CART');
            console.log(response);
          },
          error: function(error){
            console.log(error);
          }
        });

        var total = 0.00;
        $('[data-label="Total"]').each(function() {
          var htmlPrice = $(this).find(".money").html();
          var linePrice = htmlPrice.replace('$', '');
          var price = parseFloat(linePrice);
          total = total + price;
        });
        $('.cart__subtotal').find('.money').html(Shopify.formatMoney(total * 100, settings.moneyFormat));
      });
    }
  };

  validateQty = function (qty) {
    if((parseFloat(qty) == parseInt(qty)) && !isNaN(qty)) {
      // We have a valid number!
    } else {
      // Not a number. Default to 1.
      qty = 1;
    }
    return qty;
  };

  module = {
    init: init,
    load: loadCart
  };

  return module;

}(ajaxCart || {}, window.wetheme.$));
